var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Git Hash: "+_vm._s(_vm.gitHash))])
}
var staticRenderFns = []

export { render, staticRenderFns }